import { BibleBookNames, BibleBookNamesType } from "./BibleBookNames";
import { BibleGenres } from "./BibleGenres";
import { BibleVersification } from "./BibleVersification";

interface BibleBookInfo {
  name: string;
  genre: number;
  chapters: number;
  verses: number[];
}

export const BibleBookDetails: { [key in BibleBookNamesType]: BibleBookInfo } =
  {
    GEN: {
      name: BibleBookNames["GEN"],
      genre: BibleGenres.law,
      chapters: 50,
      verses: [...BibleVersification["GEN"]],
    },
    EXO: {
      name: BibleBookNames["EXO"],
      genre: BibleGenres.law,
      chapters: 40,
      verses: [...BibleVersification["EXO"]],
    },
    LEV: {
      name: BibleBookNames["LEV"],
      genre: BibleGenres.law,
      chapters: 27,
      verses: [...BibleVersification["LEV"]],
    },
    NUM: {
      name: BibleBookNames["NUM"],
      genre: BibleGenres.law,
      chapters: 36,
      verses: [...BibleVersification["NUM"]],
    },
    DEU: {
      name: BibleBookNames["DEU"],
      genre: BibleGenres.law,
      chapters: 34,
      verses: [...BibleVersification["DEU"]],
    },
    JOS: {
      name: BibleBookNames["JOS"],
      genre: BibleGenres.history,
      chapters: 24,
      verses: [...BibleVersification["JOS"]],
    },
    JDG: {
      name: BibleBookNames["JDG"],
      genre: BibleGenres.history,
      chapters: 21,
      verses: [...BibleVersification["JDG"]],
    },
    RUT: {
      name: BibleBookNames["RUT"],
      genre: BibleGenres.history,
      chapters: 4,
      verses: [...BibleVersification["RUT"]],
    },
    "1SA": {
      name: BibleBookNames["1SA"],
      genre: BibleGenres.history,
      chapters: 31,
      verses: [...BibleVersification["1SA"]],
    },
    "2SA": {
      name: BibleBookNames["2SA"],
      genre: BibleGenres.history,
      chapters: 24,
      verses: [...BibleVersification["2SA"]],
    },
    "1KI": {
      name: BibleBookNames["1KI"],
      genre: BibleGenres.history,
      chapters: 22,
      verses: [...BibleVersification["1KI"]],
    },
    "2KI": {
      name: BibleBookNames["2KI"],
      genre: BibleGenres.history,
      chapters: 25,
      verses: [...BibleVersification["2KI"]],
    },
    "1CH": {
      name: BibleBookNames["1CH"],
      genre: BibleGenres.history,
      chapters: 29,
      verses: [...BibleVersification["1CH"]],
    },
    "2CH": {
      name: BibleBookNames["2CH"],
      genre: BibleGenres.history,
      chapters: 36,
      verses: [...BibleVersification["2CH"]],
    },
    EZR: {
      name: BibleBookNames["EZR"],
      genre: BibleGenres.history,
      chapters: 10,
      verses: [...BibleVersification["EZR"]],
    },
    NEH: {
      name: BibleBookNames["NEH"],
      genre: BibleGenres.history,
      chapters: 13,
      verses: [...BibleVersification["NEH"]],
    },
    EST: {
      name: BibleBookNames["EST"],
      genre: BibleGenres.history,
      chapters: 10,
      verses: [...BibleVersification["EST"]],
    },
    JOB: {
      name: BibleBookNames["JOB"],
      genre: BibleGenres.poetry,
      chapters: 42,
      verses: [...BibleVersification["JOB"]],
    },
    PSA: {
      name: BibleBookNames["PSA"],
      genre: BibleGenres.poetry,
      chapters: 150,
      verses: [...BibleVersification["PSA"]],
    },
    PRO: {
      name: BibleBookNames["PRO"],
      genre: BibleGenres.poetry,
      chapters: 31,
      verses: [...BibleVersification["PRO"]],
    },
    ECC: {
      name: BibleBookNames["ECC"],
      genre: BibleGenres.poetry,
      chapters: 12,
      verses: [...BibleVersification["ECC"]],
    },
    SNG: {
      name: BibleBookNames["SNG"],
      genre: BibleGenres.poetry,
      chapters: 8,
      verses: [...BibleVersification["SNG"]],
    },
    ISA: {
      name: BibleBookNames["ISA"],
      genre: BibleGenres.majorProphets,
      chapters: 66,
      verses: [...BibleVersification["ISA"]],
    },
    JER: {
      name: BibleBookNames["JER"],
      genre: BibleGenres.majorProphets,
      chapters: 52,
      verses: [...BibleVersification["JER"]],
    },
    LAM: {
      name: BibleBookNames["LAM"],
      genre: BibleGenres.majorProphets,
      chapters: 5,
      verses: [...BibleVersification["LAM"]],
    },
    EZK: {
      name: BibleBookNames["EZK"],
      genre: BibleGenres.majorProphets,
      chapters: 48,
      verses: [...BibleVersification["EZK"]],
    },
    DAN: {
      name: BibleBookNames["DAN"],
      genre: BibleGenres.majorProphets,
      chapters: 12,
      verses: [...BibleVersification["DAN"]],
    },
    HOS: {
      name: BibleBookNames["HOS"],
      genre: BibleGenres.minorProphets,
      chapters: 14,
      verses: [...BibleVersification["HOS"]],
    },
    JOL: {
      name: BibleBookNames["JOL"],
      genre: BibleGenres.minorProphets,
      chapters: 3,
      verses: [...BibleVersification["JOL"]],
    },
    AMO: {
      name: BibleBookNames["AMO"],
      genre: BibleGenres.minorProphets,
      chapters: 9,
      verses: [...BibleVersification["AMO"]],
    },
    OBA: {
      name: BibleBookNames["OBA"],
      genre: BibleGenres.minorProphets,
      chapters: 1,
      verses: [...BibleVersification["OBA"]],
    },
    JON: {
      name: BibleBookNames["JON"],
      genre: BibleGenres.minorProphets,
      chapters: 4,
      verses: [...BibleVersification["JON"]],
    },
    MIC: {
      name: BibleBookNames["MIC"],
      genre: BibleGenres.minorProphets,
      chapters: 7,
      verses: [...BibleVersification["MIC"]],
    },
    NAM: {
      name: BibleBookNames["NAM"],
      genre: BibleGenres.minorProphets,
      chapters: 3,
      verses: [...BibleVersification["NAM"]],
    },
    HAB: {
      name: BibleBookNames["HAB"],
      genre: BibleGenres.minorProphets,
      chapters: 3,
      verses: [...BibleVersification["HAB"]],
    },
    ZEP: {
      name: BibleBookNames["ZEP"],
      genre: BibleGenres.minorProphets,
      chapters: 3,
      verses: [...BibleVersification["ZEP"]],
    },
    HAG: {
      name: BibleBookNames["HAG"],
      genre: BibleGenres.minorProphets,
      chapters: 2,
      verses: [...BibleVersification["HAG"]],
    },
    ZEC: {
      name: BibleBookNames["ZEC"],
      genre: BibleGenres.minorProphets,
      chapters: 14,
      verses: [...BibleVersification["ZEC"]],
    },
    MAL: {
      name: BibleBookNames["MAL"],
      genre: BibleGenres.minorProphets,
      chapters: 4,
      verses: [...BibleVersification["MAL"]],
    },
    MAT: {
      name: BibleBookNames["MAT"],
      genre: BibleGenres.gospels,
      chapters: 28,
      verses: [...BibleVersification["MAT"]],
    },
    MRK: {
      name: BibleBookNames["MRK"],
      genre: BibleGenres.gospels,
      chapters: 16,
      verses: [...BibleVersification["MRK"]],
    },
    LUK: {
      name: BibleBookNames["LUK"],
      genre: BibleGenres.gospels,
      chapters: 24,
      verses: [...BibleVersification["LUK"]],
    },
    JHN: {
      name: BibleBookNames["JHN"],
      genre: BibleGenres.gospels,
      chapters: 21,
      verses: [...BibleVersification["JHN"]],
    },
    ACT: {
      name: BibleBookNames["ACT"],
      genre: BibleGenres.gospels,
      chapters: 28,
      verses: [...BibleVersification["ACT"]],
    },
    ROM: {
      name: BibleBookNames["ROM"],
      genre: BibleGenres.paulineEpistles,
      chapters: 16,
      verses: [...BibleVersification["ROM"]],
    },
    "1CO": {
      name: BibleBookNames["1CO"],
      genre: BibleGenres.paulineEpistles,
      chapters: 16,
      verses: [...BibleVersification["1CO"]],
    },
    "2CO": {
      name: BibleBookNames["2CO"],
      genre: BibleGenres.paulineEpistles,
      chapters: 13,
      verses: [...BibleVersification["2CO"]],
    },
    GAL: {
      name: BibleBookNames["GAL"],
      genre: BibleGenres.paulineEpistles,
      chapters: 6,
      verses: [...BibleVersification["GAL"]],
    },
    EPH: {
      name: BibleBookNames["EPH"],
      genre: BibleGenres.paulineEpistles,
      chapters: 6,
      verses: [...BibleVersification["EPH"]],
    },
    PHP: {
      name: BibleBookNames["PHP"],
      genre: BibleGenres.paulineEpistles,
      chapters: 4,
      verses: [...BibleVersification["PHP"]],
    },
    COL: {
      name: BibleBookNames["COL"],
      genre: BibleGenres.paulineEpistles,
      chapters: 4,
      verses: [...BibleVersification["COL"]],
    },
    "1TH": {
      name: BibleBookNames["1TH"],
      genre: BibleGenres.paulineEpistles,
      chapters: 5,
      verses: [...BibleVersification["1TH"]],
    },
    "2TH": {
      name: BibleBookNames["2TH"],
      genre: BibleGenres.paulineEpistles,
      chapters: 3,
      verses: [...BibleVersification["2TH"]],
    },
    "1TI": {
      name: BibleBookNames["1TI"],
      genre: BibleGenres.paulineEpistles,
      chapters: 6,
      verses: [...BibleVersification["1TI"]],
    },
    "2TI": {
      name: BibleBookNames["2TI"],
      genre: BibleGenres.paulineEpistles,
      chapters: 4,
      verses: [...BibleVersification["2TI"]],
    },
    TIT: {
      name: BibleBookNames["TIT"],
      genre: BibleGenres.paulineEpistles,
      chapters: 3,
      verses: [...BibleVersification["TIT"]],
    },
    PHM: {
      name: BibleBookNames["PHM"],
      genre: BibleGenres.paulineEpistles,
      chapters: 1,
      verses: [...BibleVersification["PHM"]],
    },
    HEB: {
      name: BibleBookNames["HEB"],
      genre: BibleGenres.epistles,
      chapters: 13,
      verses: [...BibleVersification["HEB"]],
    },
    JAS: {
      name: BibleBookNames["JAS"],
      genre: BibleGenres.epistles,
      chapters: 5,
      verses: [...BibleVersification["JAS"]],
    },
    "1PE": {
      name: BibleBookNames["1PE"],
      genre: BibleGenres.epistles,
      chapters: 5,
      verses: [...BibleVersification["1PE"]],
    },
    "2PE": {
      name: BibleBookNames["2PE"],
      genre: BibleGenres.epistles,
      chapters: 3,
      verses: [...BibleVersification["2PE"]],
    },
    "1JN": {
      name: BibleBookNames["1JN"],
      genre: BibleGenres.epistles,
      chapters: 5,
      verses: [...BibleVersification["1JN"]],
    },
    "2JN": {
      name: BibleBookNames["2JN"],
      genre: BibleGenres.epistles,
      chapters: 1,
      verses: [...BibleVersification["2JN"]],
    },
    "3JN": {
      name: BibleBookNames["3JN"],
      genre: BibleGenres.epistles,
      chapters: 1,
      verses: [...BibleVersification["3JN"]],
    },
    JUD: {
      name: BibleBookNames["JUD"],
      genre: BibleGenres.epistles,
      chapters: 1,
      verses: [...BibleVersification["JUD"]],
    },
    REV: {
      name: BibleBookNames["REV"],
      genre: BibleGenres.prophecy,
      chapters: 22,
      verses: [...BibleVersification["REV"]],
    },
  };
